var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAverage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FEF3C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 15.228C15.3335 14.5366 14.7749 13.978 14.0835 13.978C13.3921 13.978 12.8335 14.5366 12.8335 15.228V28.353C12.8335 30.0796 14.2319 31.478 15.9585 31.478H31.5835C32.2749 31.478 32.8335 30.9194 32.8335 30.228C32.8335 29.5366 32.2749 28.978 31.5835 28.978H15.9585C15.6147 28.978 15.3335 28.6968 15.3335 28.353V15.228ZM31.2163 18.6108C31.7046 18.1226 31.7046 17.3296 31.2163 16.8413Cnan nan 29.9351 16.353 29.4468 16.8413L25.3335 20.9585L23.0913 18.7163C22.603 18.228 21.8101 18.228 21.3218 18.7163L16.9468 23.0913C16.4585 23.5796 16.4585 24.3726 16.9468 24.8608Cnan nan 18.228 25.3491 18.7163 24.8608L22.2085 21.3726L24.4507 23.6147C24.939 24.103 25.7319 24.103 26.2202 23.6147L31.2202 18.6147L31.2163 18.6108Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAverage);
export default __webpack_public_path__ + "static/media/ic_average.43b94b2da769f0c0e134bf28eead7471.svg";
export { ForwardRef as ReactComponent };